import React, { useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Link } from 'react-router-dom';

/* OLD CODE:
import React, { useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
*/

import { useAppSelector } from '../redux/reduxHook/useAuthActions';

export const Footer = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const isCorrupted = useAppSelector((state) => state.auth.isCorrupted);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        user.getIdTokenResult().then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (!!idTokenResult.claims.admin) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        });
      } else {
        setIsAdmin(false);
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (isCorrupted) return null;

  return (
    <footer className='mobile-hide'>
      <span>
        <nav className='footer-menu'>
          <Link to="/register" title="Sign up">Sign up</Link>
          <Link to="/" title="About">About</Link>
          <Link to="/terms-of-service" title="Terms of Service">Terms of Service</Link>
          <Link to="/privacy-policy" title="Privacy Policy">Privacy Policy</Link>
          <Link to="/referral" title="Refer a Friend">Refer a Friend</Link>
          <Link to="/data-deletion" title="Data Deletion">Data Deletion</Link>
          {isAdmin && <Link to="/admin" title="Admin">Admin</Link>}
        </nav>
        {/* OLD CODE:
            <nav className='footer-menu'>
              <a href="/register" title="Sign up">Sign up</a>
              <a href="/" title="About">About</a>
              <a href="/terms-of-service" title="Terms of Service">Terms of Service</a>
              <a href="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
              <a href="/referral" title="Refer a Friend">Refer a Friend</a>
              <a href="/data-deletion" title="Data Deletion">Data Deletion</a>
              {isAdmin && <a href="/admin" title="Admin">Admin</a>}
            </nav>
            */}
      </span>
      <span>
        Copyright © 2025 <a href="http://brather.co.uk/" target="_blank" rel="noopener noreferrer">Brather LTD</a>
      </span>
      <span>
        Website by <a href="https://queerwebdesign.com" title="Queer Web Design" target="_blank" rel="noopener noreferrer">Queer Web Design</a>
      </span>
    </footer>
  )
}